import { Reducer } from 'redux';
import { IAuditLogState } from '../common/defaults';
import { AuditLogActionTypes } from './actions';
const $ = require('jquery');
// Type-safe initialState!
const initialState: IAuditLogState = {
  logs: [],
  logTypes: [],
  selectedLogType: null,
  columns: null
};

const reducer: Reducer<IAuditLogState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case AuditLogActionTypes.GET_LOG_TYPES: {
      let _state = { ...state };
      _state = { ..._state, logTypes: action.value };
      return _state;
    }
    case AuditLogActionTypes.GET_LOGS_BY_TYPE: {
      let _state = { ...state };
      let selected = state.logTypes.filter(
        x => x.value === action.value.type
      )[0];
      let cols = [];
      if (selected && selected.viewcolumns) {
        Object.keys(selected.viewcolumns).forEach(i => {
          cols.push({
            title: selected.viewcolumns[i].title,
            mData: function(data, type, dataToSet) {
              return getValue(data, selected.viewcolumns[i].name)
                ? getValue(data, selected.viewcolumns[i].name)
                : '';
            },
            //data: selected.viewcolumns[i].name,
            datatype: selected.viewcolumns[i].datatype
          });
        });
        _state = { ..._state, columns: cols };
        _state = { ..._state, logs: action.value.logs };
        _state = { ..._state, selectedLogType: selected };
      }
      return _state;
    }

    default: {
      return state;
    }
  }
};

function getValue(object, keys) {
  return keys.split('.').reduce((o, k) => (o || {})[k], object);
}

export default reducer;
